import { render, staticRenderFns } from "./StockEventsByCleaner.vue?vue&type=template&id=2381b8de&scoped=true"
import script from "./StockEventsByCleaner.vue?vue&type=script&lang=js"
export * from "./StockEventsByCleaner.vue?vue&type=script&lang=js"
import style0 from "./StockEventsByCleaner.vue?vue&type=style&index=0&id=2381b8de&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2381b8de",
  null
  
)

export default component.exports